import { useRouter } from "next/router";

const useDateTimeFormat = (options?: Intl.DateTimeFormatOptions) => {
  const { locale } = useRouter();
  return Intl.DateTimeFormat(locale, options);
};

export default useDateTimeFormat;
